import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import { DnDList } from './components/DnDList/DnDList';
import style from './ChangePositionList.module.scss';

export const ChangePositionList: React.FC = () => {
	const dishHeadingClasses = classNames(style.dish, style.heading);
	const articleNumberHeadingClasses = classNames(style.articleNumber, style.heading);
	const stopStatusHeadingClasses = classNames(style.stopStatus, style.heading);
	const priceHeadingClasses = classNames(style.price, style.heading);
	const externalIdHeadingClasses = classNames(style.externalId, style.heading);

	return (
		<div className={style.container} data-test="ChangePositionList">
			<div className={style.tableHeaders}>
				<Text
					className={dishHeadingClasses}
					translationNameSpace="listing"
					translationKey="dishLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleNumberHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={stopStatusHeadingClasses}
					translationNameSpace="listing"
					translationKey="stopStatusLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={priceHeadingClasses}
					translationNameSpace="listing"
					translationKey="priceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={externalIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="externalIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			<DnDList />
		</div>
	);
};
